import { useEffect, useState } from 'react';
import { fetchProfile, fetchLicenseRules } from '../services/api';
import AccountSettings from './AccountSettings';

export default function SettingsPage() {
  const [profile, setProfile] = useState<any>(null);
  const [rules, setRules] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      fetchProfile().catch(() => null),
      fetchLicenseRules().catch(() => []),
    ])
      .then(([p, r]) => {
        setProfile(p);
        setRules(r);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <AccountSettings />
      {/* Profile section */}
      <div className="card">
        <h3>Profil de l'établissement</h3>
        <div className="table-wrap" style={{ marginTop: 16 }}>
          <table>
            <tbody>
              <tr><td style={{ fontWeight: 600, width: 200 }}>Nom</td><td>{profile?.name || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Email</td><td>{profile?.email || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Téléphone</td><td>{profile?.phone || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Adresse</td><td>{profile?.address || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Ville</td><td>{profile?.city || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Province</td><td>{profile?.province || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Catégorie</td><td>{profile?.category ? `${profile.category} étoiles` : '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Secteur</td><td>{profile?.sector || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Statut</td><td><span className={`badge ${profile?.status === 'active' ? 'green' : 'gray'}`}>{profile?.status || '–'}</span></td></tr>
            </tbody>
          </table>
        </div>
        <div className="sub" style={{ marginTop: 12 }}>
          Les informations administratives sont suivies par l’ONT.
        </div>
      </div>

      {/* License rules section */}
      <div className="card">
        <h3>Barème des licences</h3>
        <div className="sub">Durées et montants des catégories chargés depuis les règles administratives ONT.</div>
        <div className="table-wrap" style={{ marginTop: 16 }}>
          <table>
            <thead>
              <tr><th>Type d'activité</th><th>Catégorie</th><th>Libellé</th><th>Durée</th><th>Montant</th></tr>
            </thead>
            <tbody>
              {rules.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucune règle configurée</td></tr>}
              {rules.map((r, i) => (
                <tr key={r.id || i}>
                  <td>{r.activity_type || '–'}</td>
                  <td>{r.category_code || '–'}</td>
                  <td>{r.category_label || '–'}</td>
                  <td>{r.validity_months ? `${r.validity_months} mois` : '–'}</td>
                  <td>{r.renewal_amount != null ? `${r.renewal_amount} ${r.currency || 'USD'}` : '–'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
